import React from 'react';
import styled from 'styled-components';

import Operator, { OperatorProps } from '../Operator';
import { DropdownProps } from '../../../Dropdown';
import { VOX_STATES } from '../../../../consts/vox';

type CallType = {
  id?: string;
  pbxId?: string;
  duration?: number;
};

type ContactType = {
  name?: string;
  number?: number;
  isHidden?: boolean;
};

type OperatorType = {
  name: string;
  number: string;
  state: string;
  skillGroups: string[];
  canCall: boolean;
  canTransfer: boolean;
  canListen: boolean;
  canRequestHelp: boolean;
  isCallCenter?: boolean;
};

export interface IPhoneMonitoring {
  className?: string;
  operators: Array<{
    call?: CallType;
    contact?: ContactType;
    operator: OperatorType;
  }> | null;
  searchQuery?: string;
  visibleOnly?: string[];
  onCall: OperatorProps['onCall'];
  onTransfer: OperatorProps['onTransfer'];
  onListen: OperatorProps['onListen'];
  onRequestHelp: OperatorProps['onRequestHelp'];
  onToggle?: DropdownProps['onToggle'];
}

const PhoneMonitoring = ({
  operators,
  onCall,
  onTransfer,
  onListen,
  onRequestHelp,
  searchQuery = '',
  visibleOnly = ['all'],
  ...props
}: IPhoneMonitoring) => {
  const isVisible = ({ operator }) => {
    let visible = true;
    const { name, number, state, isCallCenter } = operator;
    const { ONLINE, READY, IN_SERVICE } = VOX_STATES;

    if (searchQuery.length > 0) {
      const checkName = name.toLowerCase().includes(searchQuery.toLowerCase());
      const checkNumber = number.includes(searchQuery);
      visible = checkName || checkNumber;
    }

    if (visibleOnly[0] === 'online') {
      visible = visible && [ONLINE, READY, IN_SERVICE].includes(state);
    }

    if (visibleOnly[0] === 'operators') {
      visible = visible && isCallCenter;
    }

    return visible;
  };

  return (
    <StyledPhoneMonitoring {...props}>
      {operators?.map(
        operatorData =>
          isVisible(operatorData) && (
            <Operator
              {...operatorData}
              onCall={onCall}
              onTransfer={onTransfer}
              onListen={onListen}
              onRequestHelp={onRequestHelp}
            />
          )
      )}
    </StyledPhoneMonitoring>
  );
};

const StyledPhoneMonitoring = styled.ul`
  width: 400px;
`;

export default PhoneMonitoring;
